import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseResourceFormComponent } from 'src/app/components/shared/components/base-resource-form/base-resource-form.component';
import { RedirectService } from 'src/app/components/shared/services/redirect.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent extends BaseResourceFormComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private redirectService: RedirectService,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.redirect();
  }

  private redirect() {
    this.route.params.subscribe((res) => {

      if (res?.jwt) {
        this.authService.removeOnlyToken('userToken');
      }

      if (res?.jwt) {
        this.authService.refreshToken(res.jwt).subscribe({
          next: (response) => {
            const refreshedToken = response?.data;
            if (refreshedToken) {
              if (res.component) {
                this.authService.createUserSession(
                  refreshedToken,
                  'true',
                  null,
                  res.component
                );
              } else if (res.bookingId) {
                this.authService.createUserSession(
                  refreshedToken,
                  'true',
                  res.bookingId,
                  null
                );
              }
            } else {
              this.notificationService.messageError(
                'Não foi possível atualizar o token.', undefined, undefined, 'bottom'
              );
              this.redirecLoginError(res.component, res.bookingId);
            }
          },
          error: (err) => {
            console.error('Erro ao atualizar token', err);
            this.notificationService.messageError('Sessão anterior expirada, por favor entre novamente', 4000, undefined, 'bottom');
            this.redirecLoginError(res.component, res.bookingId);
          },
        });
      } else {
        this.notificationService.messageError(
          'Não foi possível atualizar o token.', undefined, undefined, 'bottom'
        );
        this.redirecLoginError(res.component, res.bookingId);
      }
    });
  }

  createFrom(): void {

  }

  private redirecLoginError(component?: string, bookingId?: string): void {
    if (!component) {
      this.redirectService.setRedirectComponent('booking-agent');
      this.redirectService.setRedirectBookingId(bookingId);
    } else {
      this.redirectService.setRedirectComponent(component);
    }

    this.router.navigate(['/login']);
  }
}
